/* Inner Empire app offer popup (snippets/app-offer-popup.liquid). 2026-10-17.
   Opens once per visit: phones after 20 s or half way down, computers on exit intent. Suppressed for 14 days after a
   close, forever on this browser after a claim, and for anyone Klaviyo already knows by email. The 3D phone (shared
   viewer load only when the popup opens. Storage failures (private mode) only mean the popup may show again. */
(function(){
  var el=document.getElementById('app-offer'); if(!el||window.__appOffer)return; window.__appOffer=1;
  var K='stAppOffer', DAY=864e5;
  function get(){try{return JSON.parse(localStorage.getItem(K)||'{}')}catch(e){return {}}}
  function put(o){try{var c=get();for(var k in o)c[k]=o[k];localStorage.setItem(K,JSON.stringify(c))}catch(e){}}
  function knownToKlaviyo(){try{var m=document.cookie.match(/(?:^|; )__kla_id=([^;]+)/);if(!m)return false;var j=JSON.parse(atob(decodeURIComponent(m[1])));return !!(j.$email||j.$exchange_id)}catch(e){return false}}
  var st=get();
  if(st.claimed||(st.closed&&Date.now()-st.closed<14*DAY)||knownToKlaviyo())return;
  var ua=navigator.userAgent||'', ios=/iPhone|iPad|iPod/.test(ua)||(/Macintosh/.test(ua)&&navigator.maxTouchPoints>1), android=/Android/i.test(ua);
  var phone=ios||android||window.matchMedia('(max-width:749px), (pointer:coarse)').matches;
  var opened=false, t0=Date.now();
  /* Store buttons for this device everywhere in the popup (both on a computer). */
  [].forEach.call(el.querySelectorAll('[data-store]'),function(a){var s=a.getAttribute('data-store');a.hidden=(ios&&s==='android')||(android&&s==='ios')});
  /* The 3D phone: the Inside the Inner Empire shared embed, loaded only now. */
  function phoneModel(){
    var box=el.querySelector('[data-aop-phone]'); if(box.firstChild)return;
    var w=window.matchMedia('(min-width:600px)').matches?96:window.matchMedia('(max-height:620px)').matches?60:78;
    function draw(){ if(window.InsideInnerEmpire&&window.InsideInnerEmpire.phone){window.InsideInnerEmpire.phone(box,{width:w});return true} return false }
    if(draw())return;
    var src=el.getAttribute('data-embed'), sc=document.querySelector('script[src="'+src+'"]');
    if(!sc){sc=document.createElement('script');sc.src=src;sc.async=true;document.head.appendChild(sc)}
    sc.addEventListener('load',draw); var n=0, t=setInterval(function(){if(draw()||++n>40)clearInterval(t)},250);
  }
  function open(){
    if(opened)return; opened=true; el.hidden=false; if(!phone)el.classList.add('aop--desk'); phoneModel();
    document.documentElement.style.overflow='hidden';
    setTimeout(function(){var i=el.querySelector('#aop-email');try{i.focus({preventScroll:true})}catch(e){}},50);
    try{window.dispatchEvent(new CustomEvent('app-offer:open'))}catch(e){}
  }
  function close(){ el.hidden=true; document.documentElement.style.overflow=''; if(!get().claimed)put({closed:Date.now()}) }
  el.addEventListener('click',function(e){ if(e.target.closest('[data-aop-close]'))close() });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!el.hidden)close() });
  if(phone){
    setTimeout(open,20000);
    window.addEventListener('scroll',function on(){ var h=document.documentElement.scrollHeight-innerHeight; if(h>0&&scrollY/h>=.5){window.removeEventListener('scroll',on);open()} },{passive:true});
  } else {
    document.addEventListener('mouseout',function(e){ if(!e.relatedTarget&&e.clientY<=0&&Date.now()-t0>3000)open() });
  }
  function step(n){ [].forEach.call(el.querySelectorAll('[data-aop-step]'),function(s){s.hidden=s.getAttribute('data-aop-step')!==n}) }
  var form=el.querySelector('[data-aop-form]'), err=el.querySelector('[data-aop-err]'), btn=form.querySelector('button[type=submit]');
  form.addEventListener('submit',function(e){
    e.preventDefault(); err.hidden=true; err.textContent='';
    var email=String(form.email.value||'').trim().toLowerCase();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)){err.textContent='Enter a valid email.';err.hidden=false;return}
    btn.disabled=true; var lbl=btn.textContent; btn.textContent='Unlocking...';
    fetch(el.getAttribute('data-api'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:email,consent:!!form.consent.checked,
      consent_text:form.consent.checked?'Send me drops and offers':'',source:'homepage-popup',elapsedMs:Date.now()-t0,company_fax:form.company_fax.value||''})})
      .then(function(r){return r.json().catch(function(){return {}}).then(function(j){if(!r.ok)throw new Error(j.error||('HTTP '+r.status));return j})})
      .then(function(j){
        put({claimed:Date.now()});
        if(form.consent.checked&&window.klaviyo&&window.klaviyo.identify){try{window.klaviyo.identify({email:email})}catch(e){}}
        if(j.status==='existing'&&j.code){el.querySelector('[data-aop-code]').textContent=j.code;step('existing')}
        else if(j.status==='already_claimed'){step('already')}
        else if(j.status==='pending'){
          el.querySelector('[data-aop-email]').textContent=email;
          step('pending')}
        else throw new Error('Unexpected answer');
      })
      .catch(function(e){console.warn('[app-offer] claim failed:',e.message);err.textContent='Something went wrong. Please try again.';err.hidden=false})
      .then(function(){btn.disabled=false;btn.textContent=lbl});
  });
  el.querySelector('[data-aop-copy]').addEventListener('click',function(){
    var c=el.querySelector('[data-aop-code]').textContent, b=this;
    function done(){b.textContent='Copied'}
    if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(c).then(done,function(){fallback()});else fallback();
    function fallback(){var t=document.createElement('textarea');t.value=c;document.body.appendChild(t);t.select();try{document.execCommand('copy');done()}catch(e){}document.body.removeChild(t)}
  });
  window.AppOffer={open:open,close:close};
})();
